import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=5870cec6&"
import script from "./SubscriptionList.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionList.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports